<template>
	<div class="session-list-item ui-elevation-1 panel">
		<div class="session-list-item__header">
			<ui-button
				v-if="!session.uri.includes('@web.rec')"
				:class="{ active: isFavoriteReady }"
				:disabled="!isFavoriteReady"
				:icon="`${session.contact.favorite ? 'fa' : 'fal'} fa-star fa-fw`"
				@click="toggleFavorite"
			/>
			<div class="session-list-item__header__title">
				<div
					v-if="session.name || session.contact.name"
					class="session-list-item__header__title__name ui-subheading"
				>
					{{ session.name ? session.name : session.contact.name }}
				</div>
				<div
					:class="(session.name || session.contact.name) ? 'ui-caption' : 'ui-subheading'"
					:style="[(!session.name && !session.contact.name) ? { lineHeight: '40px' } : {}]"
					class="session-list-item__header__title__uri"
				>
					{{ session.uri }}
				</div>
			</div>
			<i
				v-if="session.streamuri"
				:title="session.streamuri"
				class="fa fa-stream"
			></i>
		</div>
		<div class="session-list-item__content">
			<div
				v-if="session.established === 0"
				class="session-list-item__content__connecting"
			>
				<div class="ui-title">Connecting...</div>
			</div>
			<dynamic-duration
				v-if="session.established === 1"
				:duration="session.duration"
				class="ui-display-2"
			/>
			<ui-button
				icon="fas fa-square"
				large
				raised
				secondary
				@click="$emit('stop', session)"
			/>
		</div>
		<ui-progress
			v-if="session.established === 0"
			:stroke="2"
			type="bar"
		/>
		<div class="session-list-item__footer">
			<div>
				<div class="ui-caption">Bandwidth</div>
				<div>{{ session.bw }} kbit/s</div>
			</div>
			<div>
				<div class="ui-caption">Audio pkt. loss</div>
				<div>{{ session.audio.loss }}%</div>
			</div>
			<div>
				<div class="ui-caption">Video pkt. loss</div>
				<div>{{ session.video.loss }}%</div>
			</div>
		</div>
	</div>
</template>

<script>
import DynamicDuration from "session/ui/DynamicDuration";
import UiButton from "lib/components/ui/Button";
import UiProgress from "lib/components/ui/Progress";

export default {
	name: "SessionItemRecord",
	components: {
		DynamicDuration,
		UiButton,
		UiProgress
	},
	props: {
		session: {
			type: Object,
			required: true
		}
	},
	computed: {
		isFavoriteReady() {
			return typeof this.session.contact.favorite !== "undefined";
		}
	},
	methods: {
		toggleFavorite() {
			$bus.$emit("_session/ui/FavoriteDialog.open", this.session.contact);
		}
	}
};
</script>

<style lang="scss" scoped>
.session-list-item {
	order: 2;
	.session-list-item__header {
		display: grid;
		grid-template-columns: 52px auto 42px;
		align-content: center;
		height: 56px;
		button {
			justify-self: center;
			&.active {
				/deep/ i {
					color: var(--ui-theme-secondary);
				}
			}
		}
		.session-list-item__header__title {
			overflow: hidden;
			white-space: nowrap;
			.session-list-item__header__title__name {
				line-height: 23px;
			}
			.session-list-item__header__title__name,
			.session-list-item__header__title__uri {
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
		i {
			font-size: 24px;
			align-self: center;
			margin-left: 4px;
			color: var(--ui-theme-secondary);
		}
	}
	.session-list-item__content {
		background-color: rgba(0, 0, 0, 0.12);
		height: 72px;
		button {
			margin-top: 8px;
			float: right;
		}
		.dynamic-duration {
			float: left;
			margin-top: 12px;
			margin-left: 8px;
		}
		.session-list-item__content__connecting {
			margin-left: 8px;
			.ui-title {
				float: left;
				line-height: 72px;
			}
		}
	}
	.ui-progress-bar {
		margin-bottom: -2px;
	}
	.session-list-item__footer {
		padding: 8px;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 10px;
		>div {
			place-self: center;
			text-align: center;
		}
	}
}

// IE11 specific, using flex due to poor grid support
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.session-list-item {
		margin: 8px;
		min-width: 312px;
		align-self: flex-start;
		.session-list-item__header {
			display: flex;
			button {
				align-self: center;
			}
			.session-list-item__header__title {
				flex-grow: 1;
				align-self: center;
			}
			i {
				margin-right: 12px;
				cursor: default;
			}
		}
		.session-list-item__footer {
			display: flex;
			justify-content: space-around;
		}
	}
	// 2 columns
	@media (min-width: 732px) {
		.session-list-item {
			max-width: 454px;
		}
	}
	// 3 columns
	@media (min-width: 1200px) {
		.session-list-item {
			max-width: 366px;
		}
	}
}
</style>
